import React from 'react'
import './header.css'
import CTA from './CTA'
import ME from '../../assets/portfolio_imagee.png'
import HeaderSocial from './HeaderSocials'

const Header = () => {
  return (
    <header >
      <div className="container header_container">
        <div className="Intro">
        <h5>Hi I'm</h5>
        <h1>Ekuma Chidinma</h1>
        <h5 className="text-heavy"> A Software Developer </h5>
          <p className="text-light">passionate about AI, scalable systems, mobile apps <br className="tablet-break" /> and data-driven solutions.</p>
        </div>
        <CTA/>
        <HeaderSocial />

        <div className="me">
          <img src={ME} alt="me" />
        </div>

        <a href="#contact" className='scroll__down'>Scroll Down</a>
      </div>
    </header>
  )
}

export default Header